import { retrievedOrderModalDict } from './orders'

const ORDER_PAGE = {
  title: 'Pedido',
  numberAbbreviation: 'Nº',
  deliveryCode: 'Código de coleta: ',
  observations: 'Observações',
  filterAll: 'Todos',
  filterDelivery: 'Delivery',
  filterScheduleds: 'Programados',
  filterPickUp: 'Pick Up',
  canBeEdited: 'Pode ser editado',
  edit: 'Editar',
  editHistoryButton: 'Histórico de edições',
  back: 'Voltar',
  backToOrders: 'Voltar para Meus Pedidos',
  subTotal: 'Subtotal',
  discount: 'Desconto',
  cashback: 'Cashback',
  cashbackDescription: 'Desconto de cashback para usuários do Zé',
  changeValue: 'Troco para',
  changeValueToClient: 'Troco do cliente',
  samplingLabel: 'Amostra',
  freight: 'Envio',
  convenienceFee: 'Taxa de Conveniência',
  heavyBagFee: 'Taxa de Pedido Grande',
  convenienceFeeTooltip:
    'Taxa de remuneração do Zé, destinada a manter a operação e garantir a melhor experiência. Esse valor não será repassado a você.',
  heavyBagFeeTooltip:
    'Taxa cobrada em pedidos volumosos, integralmente destinada ao distribuidor, que é responsável pela remuneração de entregadores.',
  extraFee: 'TAXA DE CONVENIÊNCIA',
  valueToStore: 'Taxa para pedidos grandes',
  infoIcon: 'Info icon',
  total: 'Total',
  date: 'Data',
  heldDay: 'Realizado dia',
  time: 'Horário',
  minutesToAccept: 'minutos restantes para aceitar esse pedido',
  orderFor: 'Pedido feito por',
  deliveryAddress: 'Endereço',
  pickupNoAddress: 'Sem endereço - Pedido de Retirada',
  dateTime: 'Dia e hora',
  paymentMethod: 'Forma de Pagamento',
  titleChangeStatusErrorModal: 'Não pude alterar o status do pedido',
  orderSuccessfullyAccepted: 'Pedido aceito com sucesso',
  optionARejectModal: 'Estou sem entregadores disponíveis no momento. ',
  optionBRejectModal:
    'Não tenho um ou mais produto(s) escolhido(s) para entrega. ',
  reject: 'Rejeitar',
  confirm: 'Confirmar',
  accept: 'Aceitar',
  otherPrefix: 'Outros:',
  infoEditOrderButtonCreditCardMessage:
    'Pedidos com pagamento online de cartão de crédito ainda não são editáveis',
  infoEditOrderButtonCbe: 'Pedidos de Chopp Brahma não são editáveis',
  cancelOrderModal: {
    title: 'Por que você está cancelando o pedido?',
    description:
      'Selecione o motivo que melhor descreve o motivo do cancelamento',
  },
  rejectOrderModal: {
    title: 'Por que você está rejeitando o pedido?',
    description: 'Selecione o motivo que melhor descreve o motivo da rejeição',
    offerEditModalToReject: {
      title: 'Produto em falta? Aceite e edite ao invés de rejeitar',
      subtitle: 'Aceite e edite ao invés de rejeitar',
      description1: 'Você sabia que agora você pode editar pedidos?',
      description2: 'Não perca a venda! Aceitando o pedido, você poderá:',
      option1: 'Trocar o que falta por itens similares',
      option2: 'Excluir apenas o que falta do pedido',
      rejectButton: 'Prefiro rejeitar',
      rejectingButton: 'Rejeitando...',
      acceptButton: 'Aceitar e Editar',
    },
  },
  shortcutInventoryModal: {
    title: 'Quer aproveitar e desabilitar os produtos que estão em falta?',
    successFeedback: 'Produto(s) modificado(s) com sucesso!',
  },
  selectStockoutProductsModal: {
    title: 'Quais produtos do pedido que você não tem?',
    subtitleCancellation:
      'Indique o(s) produto(s) sem estoque pra concluir o cancelamento.',
    subtitleRejection:
      'Indique o(s) produto(s) sem estoque pra concluir a rejeição.',
    footerCancellation:
      'O produto será desabilitado automaticamente do estoque após o cancelamento',
    footerRejection:
      'O produto será desabilitado automaticamente do estoque após a rejeição',
    confirmCancellation: 'Confirmar cancelamento',
    confirmRejection: 'Confirmar rejeição',
    successToast: 'Produto(s) desativado(s) do seu estoque',
    successToastSingular: 'Produto desativado do seu estoque',
  },
  textAreaPlaceholder: 'Descreva o motivo',
  orderCancellationReasonError:
    'Por favor justifique o motivo do cancelamento do pedido',
  orderRejectionReasonError:
    'Por favor justifique o motivo de rejeitar o pedido',
  tooMuchCharactersError: 'A sua mensagem não pode ter mais de 150 caracteres',
  thanks: 'Obrigado',
  cancel: 'Cancelar',
  currency: 'R$',
  at: 'às',
  dontHaveFiscalValue: 'NÃO TEM VALOR FISCAL',
  titleSite: 'Zé Delivery',
  order: 'Pedido',
  dateHour: 'Data/Hora',
  address: 'Endereço',
  user: 'Cliente',
  phone: 'Telefone',
  poc: 'Distribuidor',
  payment: 'Pagamento',
  deliveryDate: 'Data de entrega',
  deliveryType: 'Tipo do pedido',
  comment: 'Comentário',
  comments: 'Comentários',
  products: 'Produtos',
  freightPrint: 'Frete',
  orderDetails: 'Detalhes do Pedido',
  moderation: 'BEBA COM MODERAÇÃO',
  orderScheduleDate: 'Data do agendamento',
  orderRating: 'Avaliação',
  orderComment: 'Comentários',
  orderRatingReasons: 'Motivos',
  orderDeliveryToken: 'Chave Zé Entregador',
  empty: 'N/A',
  emptyReasonsError: 'Informe o motivo',
  statusHistory: 'Histórico completo',
  seeStatusHistoryResumed: '- Ver histórico resumido',
  seeStatusHistoryOpened: '+ Ver histórico completo',
  statusHistoryButton: 'Ver histórico completo',
  description: 'Descrição',
  printOnAccept: 'Imprimir pedido ao aceitar',
  choppComments: {
    cnpj: 'CNPJ: ',
    inscricaoEstadual: 'Inscrição Estadual: ',
  },
  shipping: {
    estimateShippingCallToAction: 'Estimar entrega',
    confirmAndAcceptCallToAction: 'Confirmar entrega e aceitar pedido',
    modalTitle: 'Estimativa de entrega com operador ',
    cost: 'Custo',
    eta: 'Tempo estimado de retirada',
    etaUnit: 'minutos',
    distance: 'Distância aproximada',
    distanceUnit: 'km',
    chargeMethod: 'Método de cobrança',
  },
  orderSummary: 'Resumo do pedido',
  deliveryTypes: {
    scheduled: 'Programado',
    turbo: 'Turbo',
    receive: 'Comum',
    pickup: 'Retirada',
    banner: {
      RECEIVE: 'Pedido Comum',
      PICKUP: 'Pedido de Retirada',
      SCHEDULED: 'Pedido Programado',
      PENDING: 'Aguardando o aceite',
      TURBO: 'Pedido Turbo',
    },
    choppSchedule: {
      tag: ['Entrega agendada para', 'das', 'às', ''],
    },
  },
  turbo: 'Pedido Turbo',
  explanedDeliveryTurbo: ' - entregar até',
  between: 'entre',
  and: 'e',
  for: 'para',
  people: 'pessoas',
  productsSum: 'Soma dos produtos',
  totalPayable: 'Total a pagar',
  symbol: 'R$',
  customerSwitching: 'Troco do cliente',
  disregard: 'Desconsiderar',
  print: 'Imprimir',
  transfer: 'Transferir',
  affiliate: 'Pedido via',
  key: 'Chave',
  courier: 'Zé Entregador',
  queryErrorModal: {
    title: 'Tivemos um pequeno problema!',
    message:
      'Não foi possível exibir as informações devido a uma instabilidade técnica.',
    primaryButton: 'Tentar Novamente',
    secondaryButton: 'Voltar',
  },
  notFoundErrorModal: {
    title: 'Pedido indisponível :(',
    message:
      'Parece que este pedido não existe ou não é mais gerenciado por sua loja.',
    button: 'Ir para a página inicial',
  },
  neighborhood: 'Bairro',
  titleOrderTransferModal: 'Ordem de transferência',
  onlinePaymentLabel: 'Online',
  onlinePaymentBadgeInfo: 'Pagamento pelo app. Não cobrar.',
  closeDisregardModalPOC: 'Fechar',
  viewMap: 'Visualizar',
  phoneViewedAfterCompleted: 'Contato após pedido finalizado',
  temperatureInfo: 'Bebidas em temperatura ambiente',
  other: 'Outro',
  unavailableInfo: {
    address: {
      link: 'Endereço indisponível',
      title: 'Endereço indisponível',
      message:
        'Ops! O endereço desse cliente não está disponível. Entre em contato com o Zé pelo chat informando o problema e o número do pedido.',
    },
    phone: {
      link: 'Telefone indisponível',
      title: 'Telefone indisponível',
      message:
        'Ops! O telefone desse cliente não está disponível. Entre em contato com o Zé pelo chat informando o problema e o número do pedido.',
    },
    button: 'Fechar',
  },
  close: 'Fechar',
  viewPhone: 'Ver telefone',
  submit: 'Confirmar',
  showPhoneReasonsTitle: 'Qual é o motivo para o contato com o cliente?',
  contactClientDialog: {
    reasonSubtitle:
      'Selecione o motivo que melhor descreve o contato com o cliente',
    contactTitle: 'Contato com cliente',
    phoneNumberLabel: 'Número do %NAME',
    phoneNumberClientLabel: 'Número do cliente',
    whatsappCta: 'Falar via Whatsapp',
    editOrder: 'Editar pedido',
  },
  otherReasonText: 'Descreva o motivo para entrar em contato',
  viewPhoneGenericError: 'Houve um erro, tente novamente mais tarde',
  abbreviatedQuantity: 'Qtd',
  limitedPromoBadge: 'Promo Ltda',
  limitedPromoTooltip:
    'A promoção foi aplicada apenas nestas unidades. Por isso o produto aparece separado em dois.',
  money: 'R$',
  pickup: {
    confirm: 'Confirmar retirada',
    tag: 'Retirada',
    modal: {
      title: 'Código de entrega',
      titleConfirm: 'Confirmação da retirada',
      titleProblemsWithCode: 'Problemas com o código?',
      titleProblemsWithCodeDescription:
        'Encontre respostas para as dúvidas mais comuns sobre o código de entrega.',
      description: 'Digite os 4 dígitos do código',
      content: 'Tem certeza de que deseja confirmar a retirada?',
      alertMessage:
        'O código é o dia + ano de nascimento cadastrado no app do cliente',
      buttons: {
        continue: 'Confirmar',
        cancel: 'Cancelar',
        yes: 'Sim',
        no: 'Não',
        back: 'Voltar',
      },
      problemWithCode: 'Problemas com o código?',
      incorrectCode: 'Código incorreto',
      attempt: 'tentativas',
      maxAttempts: 'Máximo de tentativas atingido.',
      maxAttemptsByPass: 'Número máximo de tentativas atingido.',
      maxAttemptsMessage: 'Entre em contato com o suporte para continuar',
      finishWithoutCode: 'Finalizar a entrega sem o código',
      finishWithoutCodeTitle: 'Finalizar sem o código',
      finishWithoutCodeMessage:
        'Essa é a única vez que será permitido finalizar o pedido sem digitar o código.',
      problemsWithCodeOptions: {
        contactError:
          'Não foi possível buscar o telefone. Tente novamente mais tarde.',
        dontKnowCode: {
          title: 'Não sei o que é esse código',
          content: [
            'O código garante que o pedido será entregue à pessoa certa.',
            'Ele é o dia + ano de nascimento cadastrado por cliente no app do Zé (ex: 15/03/1990 = 1590).',
          ],
        },
        clientDontKnowCode: {
          title: 'O cliente não sabe qual é o código',
          content: [
            'O código está disponível no app de quem fez o pedido. Ele é o dia + ano de nascimento cadastrado no Zé (ex: 15/03/1990 = 1590).',
          ],
        },
        forgotCode: {
          title: 'Esqueci de pedir o código ao cliente',
          content: [
            'Fale com cliente para solicitar o código de entrega.',
            'Não conseguiu contato? Fale com o nosso suporte. Vamos de ajudar a finalizar o pedido.',
          ],
          callToClient: 'Falar com o cliente',
          messageToClient: 'Falar por Whatsapp',
        },
        clientDontPassCode: {
          title: 'O cliente não quer passar o código',
          content: [
            'Por segurança, só é possível confirmar a retirada com o código de entrega.',
            'Importante: Não entregue o pedido sem o código.',
          ],
        },
      },
      confirmBypass: {
        title: 'Confirmar a entrega do pedido ao cliente?',
        description:
          'Essa é a única vez que será permitido finalizar o pedido sem digitar o código.',
      },
    },
    toast: {
      success: 'Retirada confirmada com sucesso',
      error: 'Não foi possível confirmar a retirada neste momento.',
    },
    info: 'Após o pedido ser aceito, o cliente terá 1 hora para retirar.',
  },
  scheduled: {
    delivery: {
      deliver: 'Entregar',
      on: 'em',
      today: 'hoje',
      tomorrow: 'amanhã',
      between: 'entre',
      and: 'e',
    },
    info: ' - Temperatura ambiente',
  },
  pickedUp: 'Retirado',
  eventState: {
    NO_ANSWER: 'Ignorou a oferta',
    REJECTED: 'Recusou a oferta',
    ACCEPTED: 'Aceitou a oferta',
    NO_ANSWER_AND_EMAIL: 'Aguardando entregadores retornarem à loja',
  },
  statusLabel: {
    CS_CANCELLEDOC: 'Cancelado',
    DELIVERED: 'Entregue',
    DM_ACCEPTED: 'Entregador aceitou',
    DM_CANCELLATION_REQUEST: 'Cancelado pelo entregador',
    DM_EN_ROUTE: 'A caminho',
    DM_EXPIRED: 'Expirado',
    DM_PICKED_UP: 'Entregador Retirou',
    DM_REJECT: 'Cancelado pelo entregador',
    PENDING: 'Aguardando o aceite',
    POC_ABANDONED: 'Cancelado pela loja',
    POC_ACCEPTED: 'Aceito',
    POC_EXPIRED: 'Expirado',
    POC_PICKED_UP: 'RETIRADA',
    POC_REJECT: 'Rejeitado',
    SUSPECT: 'Desconsiderado',
    TRANSFERED: 'Pedido transferido',
    USER_CANCELLED: 'Cancelado pelo cliente',
    WAITING_CONSUMER: 'Aguardando o aceite',
    WAITING_COURIER: 'Aguardando entregador',
  },
  reasonLabel: {
    CUSTOMER_DEADLINE_EXPIRED: 'pelo cliente',
  },
  extraStatusLabel: {
    WAITING_COURIER: 'Aguardando entregador',
    WAITING_CONSUMER: 'Aguardando cliente',
  },
  firstPurchaseModal: {
    cancellation: {
      title: 'Primeiro pedido do cliente',
      subtitle: 'Tente priorizar esse pedido',
      alertMessage1: 'Se você cancelar, o cliente terá uma',
      alertMessage2: 'experiência ruim.',
      alertMessage3: 'Muitos não retornam a fazer compras',
      alertMessage4: 'após ter a sua primeira compra cancelada.',
      alertMessage5: 'Você tem certeza que quer cancelar?',
      no: 'Não',
      yes: 'Sim',
    },
    reject: {
      title: 'Primeiro pedido do cliente',
      subtitle: 'Tente priorizar esse pedido',
      alertMessage1: 'Se você rejeitar, o cliente terá uma',
      alertMessage2: 'experiência ruim.',
      alertMessage3: 'Muitos não retornam a fazer compras',
      alertMessage4: 'após ter a sua primeira compra rejeitada.',
      alertMessage5: 'Você tem certeza que quer rejeitar?',
      no: 'Não',
      yes: 'Sim',
    },
  },
  printPage: {
    subtitle: 'PRIMEIRO PEDIDO DO CLIENTE',
    tag: { alt: 'ENTREGA PRIORITÁRIA' },
    icon: {
      alt: 'Ícone de Primeira compra',
    },
    scissor: {
      alt: 'Recorte',
    },
    scheduled: {
      title: 'Programado',
      delivery: {
        deliver: 'Entregar',
        on: 'em',
        today: 'hoje',
        tomorrow: 'amanhã',
        between: 'entre',
        and: 'e',
      },
    },
    pickup: 'Retirada',
    temperature: {
      room: {
        label: 'Temperatura ambiente',
      },
    },
    heavyBag: {
      convenience: 'Taxa de conveniência',
      heavyBag: 'Taxa de pedido grande',
      label: 'Pedido grande com frete adicional',
    },
    turbo: {
      label: 'Pedido Turbo',
    },
    missingItemCustomerPreference: {
      title: 'Se Faltar Item - Preferência do Cliente:',
      exclude: 'Excluir do Pedido',
      replace: 'Trocar por similar',
      verify: 'Verificar na plataforma',
      editViaPlatform: '(editar via sistema)',
    },
    editOrder: {
      label: 'Este pedido foi editado pela loja',
      reverseBill: 'A diferença será estornada após a entrega.',
    },
  },
  canceledOrder: 'O pedido foi cancelado.',
  rejectedOrder: 'O pedido foi rejeitado.',
  temperatureLabel: {
    room: 'Entregar em temperatura ambiente',
  },
  segment: {
    macroJourney: 'order',
    microJourney: 'status',
    heavyBag: 'heavy_bag',
    button: 'button',
    iconButton: 'icon button',
    modalNameRejectConfirmClicked: 'Order Reject Modal',
    modalNameCancelConfirmClicked: 'Order Cancel Modal',
    componentNameRejectConfirmClicked: 'Order Modal Reject Confirm Button',
    componentNameCancelConfirmClicked: 'Cancel Confirm Button',
    componentNameRejectCloseClicked: 'Order Modal Reject Close Button',
    componentNameCancelCloseClicked: 'Cancel Close Button',
    showPhoneModalName: 'show_phone_reason',
    screenNametoModals: 'ORDERS, ORDER_DETAIL',
    unavailableProductModalNameCancellation:
      'Unavailable Product Modal (Cancelamento)',
    unavailableProductModalNameRejection:
      'Unavailable Product Modal (Rejeicao)',
    unavailableProductModalConfirmCancellation: 'Confirmar cancelamento',
    unavailableProductModalConfirmRejection: 'Confirmar rejeição',
    unavailableProductModalClose: 'Fechar',
    reasonSelectedUnavailableProductModal:
      'Não tenho um ou mais produtos do pedido',
    suggestionEditModalName: 'Suggestion Edit Modal',
    suggestionEditModalViewedCancellation:
      'Suggestion Edit Modal (cancelamento)',
    suggestionEditModalViewedRejection: 'Suggestion Edit Modal (Rejeicao)',
    suggestionEditModalCloseCancellation: 'Fechar (cancelamento)',
    suggestionEditModalCloseRejection: 'Fechar (rejeição)',
    suggestionEditModalPreferCancel: 'Prefiro cancelar',
    suggestionEditModalPreferReject: 'Prefiro rejeitar',
    suggestionEditModalAcceptAndEdit: 'Aceitar e editar',
    suggestionEditModalEditOrder: 'Editar pedido',
    reasonsCancelModalName: 'Reasons Cancel Modal',
    reasonsRejectModalName: 'Reasons Reject Modal',
    orderEditClickedAfterReasonSelection:
      'Editar pedido após seleção do motivo',
    orderEditClickedBeforeReasonSelection:
      'Editar pedido antes da seleção do motivo',
  },
  stockoutCancelRetention: {
    retentionModalTitle: retrievedOrderModalDict.title,
    valuePropositionIntro: retrievedOrderModalDict.retrieveValue,
    valueTooltip: retrievedOrderModalDict.tooltipRetrieveValue,
    stepsIntro: retrievedOrderModalDict.followSteps,
    stepDecrease: retrievedOrderModalDict.step1,
    stepChooseReplace: `${retrievedOrderModalDict.step2Replace} e escolha o similar`,
    stepChooseExclude: retrievedOrderModalDict.step2Delete,
    stepChooseReplaceOrExclude: `${retrievedOrderModalDict.step2Delete} ou pela substituição e escolha o similar`,
    stepFinalize: retrievedOrderModalDict.step3,
    preferCancelAndLose: 'Prefiro cancelar',
    editAndSaveOrder: 'Editar e salvar o pedido',
    editOrderInReasonModal: 'Editar pedido',
    stepNumbers: ['1', '2', '3'],
  },
  offerEditModalToCancel: {
    title: 'Que tal editar ao invés de cancelar o pedido?',
    subtitle: 'Você sabia que agora dá pra editar pedidos?',
    description: 'Não perca a venda! Editando o pedido você poderá:',
    description1: 'Você sabia que agora dá pra editar pedidos?',
    description2: 'Não perca a venda! Editando o pedido você poderá:',
    option1: 'Trocar o que falta por itens similares',
    option2: 'Excluir apenas o que falta do pedido',
    cancelButton: 'Prefiro cancelar',
    cancellingButton: 'Cancelando...',
    editButton: 'Editar pedido',
    changeText: 'Alterar pedido',
    removeText: 'Remover item',
    changeImageAlt: 'Retornar garrafa',
  },
  failedToChangeStatus:
    'Não foi possível alterar o status do pedido nesse momento. Atualize a página e tente novamente.',
  paymentType: {
    pix: 'Pix',
    nupay: 'Nupay',
    onlinePayment: 'Conta Bancária do Cartão',
  },
  revertEditSuccess: 'Você reverteu o pedido',
  revertEditError: 'Não foi possível reverter o pedido',
  revertToInitialOrderButton: 'Reverter ao pedido inicial',
}

export default ORDER_PAGE
